import React from "react";
import { useNavigate } from "react-router-dom";
import { BLOGS } from "../../constants/constants";
import styles from "./Blogs.module.css";
import BannerHeader from "../../components/BannerHeader/BannerHeader";

const BlogCard = ({
  title,
  summary,
  image,
  onClick,
  publishedDate,
  noShadow = false,
}) => {
  return (
    <div
      className={noShadow ? styles.cardNoShadow : styles.card}
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-pressed="false"
    >
      <div className={styles.imageWrapper}>
        <img src={image} alt={title} className={styles.image} />
      </div>
      <div className={styles.description}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.summary}>{summary}</p>
        </div>
        <div className={styles.date}>
          {new Date(publishedDate).toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </div>
      </div>
    </div>
  );
};

const Blogs = () => {
  const navigate = useNavigate();
  const featured = BLOGS[0];
  const recentPosts = BLOGS.slice(1);

  // Generate BlogPosting structured data for all blogs
  const blogStructuredData = BLOGS.map((blog) => ({
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blog.title,
    image: blog.image,
    datePublished: blog.publishedDate,
    author: blog.author || "Green Rock Creations",
    description: blog.summary,
    url: `https://www.greenrockcreations.com/blog/${blog.slug}`,
  }));

  return (
    <>
      <div className={styles.mainContainer}>
        <BannerHeader />
        <section className={"container"}>
          <div className={styles.blogsHeader}>
            <h1 className="heading">Blog & Insights</h1>
            <p className="subheading">
              Explore the latest trends, tips, and expert advice on lab grown
              diamonds, jewelry, and sustainable luxury. Stay inspired and
              informed!
            </p>
          </div>
          <div
            className={styles.featuredBlogFullWidth}
            onClick={() => navigate(`/blog/${featured.slug}`)}
          >
            <img
              src={featured.image}
              alt={featured.title}
              className={styles.featuredBlogImage}
            />
            <div className={styles.featuredBlogDetails}>
              <span className={styles.featuredBlogDate}>
                {new Date(featured.publishedDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
              <h2 className={styles.featuredBlogTitle}>{featured.title}</h2>
              <p className={styles.featuredBlogSummary}>{featured.summary}</p>
              <span
                className={styles.featuredBlogRead}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/blog/${featured.slug}`);
                }}
              >
                Read article
              </span>
            </div>
          </div>
          <div className={styles.recentSection}>
            <div className={styles.recentHeader}>
              <h2 className={styles.recentTitle}>Recent Posts</h2>
              {/* <button
              className={styles.allPostsBtn}
              onClick={() => navigate("/blogs")}
            >
              All Posts
            </button> */}
            </div>
            <div className={styles.grid}>
              {recentPosts.slice(0, 6).map((blog) => (
                <BlogCard
                  key={blog.id}
                  title={blog.title}
                  summary={blog.summary}
                  image={blog.image}
                  onClick={() => navigate(`/blog/${blog.slug}`)}
                  publishedDate={blog.publishedDate}
                  category={blog.category}
                  noShadow
                />
              ))}
            </div>
          </div>
        </section>
      </div>
      <title>
        Green Rock Creations - Lab Grown Diamond Blog & Insights | Diamond
        Retailers USA, Europe, Hong Kong, India
      </title>
      <meta
        name="description"
        content="Explore the latest trends, tips, and expert advice on lab grown diamonds, jewelry, and sustainable luxury. Stay inspired and informed with Green Rock Creations' blog."
      />
      <script type="application/ld+json">
        {JSON.stringify(blogStructuredData)}
      </script>
    </>
  );
};

export default Blogs;
